import React from 'react';
import {UploadImage} from 'components/UI/Image';
import {DateTime} from 'components/UI/DateTime';
import {withRouter} from 'react-router-dom';

class RequestItem extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="item-request-wrap" onClick={() => this.props.history.push(`/my-business/requests/${this.props.id}`)}>
        <div className='product-content-wrap'>
          <div className='product-content-image-wrap'>
            <UploadImage transform="crop" type="PRODUCT" width="189" height="127" image={this.props.product.images[this.props.product.images.length -1]} />
          </div>
          <div className='product-content-name'>{this.props.product.name}</div>
        </div>
        <div className='request-content-wrap'>
          <p className='request-content-title mb10'>Nội dung yêu cầu</p>
          <p className='request-content mb10'>{this.props.description}</p>
          <div className='content-justify'>
            <p className='request-content-title'><DateTime dateTime="2017-11-07T14:48:39.956Z"/></p>
            {/* <p className='request-content-title'>10 trao đổi</p> */}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(RequestItem);



// WEBPACK FOOTER //
// ./components/my-business/requests/RequestItem.jsx